import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/CollectionMembershipLocalInventory'


// create the fragment store

export class CollectionMembershipLocalInventoryStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "CollectionMembershipLocalInventoryStore",
			variables: true,
			
		})
	}
}
